if (!customElements.get('tiburn-feature-showcase')) {
  customElements.define('tiburn-feature-showcase', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      const track = this.querySelector('.tfs__track');
      const slides = [...this.querySelectorAll('[data-slide]')];
      const dots = [...this.querySelectorAll('[data-dot]')];
      const toggle = this.querySelector('.tfs__toggle');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let paused = this.dataset.autoplay !== 'true' || reduce.matches;
      let visible = true;
      let scrollTimer;
      let progress;
      const interval = Math.max(4000, Number(this.dataset.interval) || 6000);

      const update = next => {
        index = Math.max(0, Math.min(slides.length - 1, next));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', String(i === index));
        });
      };
      const go = (next, smooth = true, restart = true) => {
        update(next);
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
        if (restart) start();
      };
      const stop = () => { progress?.pause(); };
      const start = () => {
        progress?.cancel();
        progress = undefined;
        const bar = dots[index]?.querySelector('i');
        if (!bar || paused || !visible || document.hidden || slides.length < 2 || reduce.matches) return;
        progress = bar.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: interval, easing: 'linear', fill: 'forwards' }
        );
        progress.onfinish = () => go((index + 1) % slides.length, true, true);
      };
      const resume = () => {
        if (!paused && visible && !document.hidden && !reduce.matches) {
          if (progress?.playState === 'paused') progress.play(); else if (!progress) start();
        }
      };
      const syncToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Play feature slideshow' : 'Pause feature slideshow');
        toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      };

      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), opts));
      toggle?.addEventListener('click', () => { paused = !paused; syncToggle(); if (paused) stop(); else resume(); }, opts);
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const nearest = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft - track.offsetLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft - track.offsetLeft) ? i : best, 0);
          if (nearest !== index) { update(nearest); start(); }
        }, 80);
      }, { passive: true, signal: controller.signal });
      track.addEventListener('pointerenter', stop, opts);
      track.addEventListener('pointerleave', resume, opts);
      track.addEventListener('focusin', stop, opts);
      track.addEventListener('focusout', resume, opts);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : resume(), opts);
      reduce.addEventListener('change', () => { paused = reduce.matches; syncToggle(); if (paused) stop(); else start(); }, opts);

      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; if (visible) resume(); else stop(); }, { threshold: .15 });
      observer.observe(this);
      syncToggle();
      start();
      this.cleanup = () => { controller.abort(); observer.disconnect(); progress?.cancel(); clearTimeout(scrollTimer); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
